// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607301746/js/" + chunkId + "." + {"44":"e78007bb","225":"2446af1f","481":"d6f98ba1","486":"faeb9caa","770":"89ab9c16"}[chunkId] + ".0.8144898647829676.chunk.js";
};